export default {
    api: process.env.NODE_ENV === 'development' ? 'http://localhost:5002' : 'https://api.martendenheijer.nl/data-service/v3'
        //https://data-service-v3-q5hqs.ondigitalocean.app
        //https://core-data-service.herokuapp.com
        //http://188.166.104.173:3000

}



// WEBPACK FOOTER //
// ./src/config/index.js